import { useState, useEffect, useCallback } from 'react'

const useScrollDirection = () => {
  const [scrollDirection, setScrollDirection] = useState('down')
  const [prevScrollY, setPrevScrollY] = useState(0)

  const handleScroll = useCallback(() => {
    const currentScrollY = window.scrollY

    if (currentScrollY > prevScrollY) {
      setScrollDirection('down')
    } else {
      setScrollDirection('up')
    }

    setPrevScrollY(currentScrollY)
  }, [prevScrollY])
  useEffect(() => {
    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [prevScrollY, handleScroll])

  return scrollDirection
}

export default useScrollDirection
